import React from "react";
import { FaWhatsapp } from "react-icons/fa6";

const WhatsAppButton = () => {
  const phoneNumber = "919034032446";
  const message = "Hello, I would like to know more.";

  const handleClick = () => {
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <button
      onClick={handleClick}
      className="fixed text-center bottom-12 right-0.5 z-50 bg-green-500 text-white p-1.5 rounded-full shadow-lg hover:scale-110 transition-transform duration-300"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={20} />
    </button>
  );
};

export default WhatsAppButton;